// extracted by mini-css-extract-plugin
export default {"plate":"OtmStatusTemplate_plate__uA1mP","yellow":"OtmStatusTemplate_yellow__cLjVa","green":"OtmStatusTemplate_green__Yu4dt","gray":"OtmStatusTemplate_gray__KpG65"};